import React from 'react'
import { Switch } from '@app/components/util'

import { SELECT_DROPDOWN_RENDER_TYPE } from '@app/components/base/Select/constants'

import { AcceptRender } from './AcceptRender'
import { ExcludedRender } from './ExcludedRender'

import type { DropdownRenderProps } from './types'

const { Case } = Switch

export const DropdownRender: React.FC<DropdownRenderProps> = ({
  dropdownRenderType,
  menu,
  onAccept,
  isExcluded,
  onChangeExcluded
}) => (
  <Switch fallback={ menu }>
    <Case condition={ dropdownRenderType === SELECT_DROPDOWN_RENDER_TYPE.acceptable }>
      <AcceptRender
        menu={ menu }
        onAccept={ onAccept }
      />
    </Case>
    <Case condition={ dropdownRenderType === SELECT_DROPDOWN_RENDER_TYPE.excluded }>
      <ExcludedRender
        menu={ menu }
        isExcluded={ isExcluded }
        onChange={ isExcluded => onChangeExcluded?.(isExcluded) }
      />
    </Case>
  </Switch>
)
